import { render } from "./ProfilePhotoEdit.vue?vue&type=template&id=39e9dca6&lang=pug"
import script from "./ProfilePhotoEdit.vue?vue&type=script&lang=js"
export * from "./ProfilePhotoEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__